<template>
	<BaseCmsPage :fetch-slug-segments="2">
		<BaseThemeWebshopPageContent />
		<div class="base-webshop-page-modules">
			<ClientOnly>
				<LazyBaseThemeWebshopKeksPay v-if="kekspay" />
				<template #fallback>
					<BaseThemeUiLoading />
				</template>
			</ClientOnly>
		</div>
	</BaseCmsPage>
</template>

<script setup>
	const kekspay = __KEKSPAY__;
</script>
